module.exports = __webpack_public_path__ + "static/media/Aromatisse_gaussian2.d9133dfc.png";